import {
  Container,
  Logo,
} from './index'

interface SlimLayoutProps {
  children: React.ReactNode
  showFooter?: boolean
}

export function SlimLayout({
 children, showFooter = true 
}: SlimLayoutProps) {
  return (
    <div className="flex min-h-full flex-col justify-center bg-gray-50 py-12 sm:px-6 lg:px-8">
      <Container className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Logo className="h-12 w-auto" />
        </div>
        {children}
      </Container>
      {showFooter && (
        <div className="mt-8 text-center text-sm text-gray-600">
          <p>© 2024 Your Company. All rights reserved.</p>
        </div>
      )}
    </div>
  )
} 